import React from 'react';
import './ProceduresContent.css'; // Assuming you have a CSS file for styling
import { Link } from 'react-router-dom';

const ProceduresContent = () => {
  return (
    <div className="procedures-content">
      <div className="procedures-overview-container">
        <div className="procedures-overview-info">
            <h1 className="our-services-header">Explore Our Services</h1>
            <div className="our-services-custom-line"></div>
            <p className="procedures-overview-text">
                Whether your dental needs are a complete exam and cleaning, a full-mouth restoration, or anything in between, we promise to provide you with exceptional care as we enhance the natural beauty of your smile. 
                Here are just some of the many procedures and services we regularly provide to our patients with a gentle touch, and stunning results. Your smile is our first priority, and we’ll give you something to smile about.
                If you have any questions, concerns, or would like to schedule an appointment, please contact us today. We look forward to providing you with the personal care you deserve.
            </p>
        </div>
      </div>

      <div className="procedures-sections-container">
        <div className="procedure-cards">
            <div className="procedure-card">
                <img src="/images/preventative-oral-care.jpeg" alt="Teeth Whitening" className="procedure-card-image" />
                <h2 className="procedure-card-title">Preventative Oral Care</h2>
                <p className="procedure-card-text">
                    A preventive program is a cooperative effort by the patient, dentist, and dental staff to preserve the natural dentition and supporting structures by preventing the onset, progress, and recurrence of dental diseases and conditions.
                </p>
                <p className="procedure-card-text">
                    Prevention helps avoid serious and costly dental problems and is the key to having a healthy, confident, beautiful smile.
                </p>
                <div className="procedure-custom-line"></div>
                <ul className="procedure-card-selection">
                    <li className="procedure-card-item">
                        <Link to="/procedures/exams-and-cleanings" className="procedure-card-link">Dental Cleanings and Exams</Link>
                    </li>
                    <li className="procedure-card-item">
                        <Link to="/procedures/x-rays" className="procedure-card-link">Dental X-Rays</Link>
                    </li>
                </ul>
            </div>
            <div className="procedure-card">
                <img src="/images/restorative-dentistry.jpeg" alt="Restorative Dentistry" className="procedure-card-image" />
                <h2 className="procedure-card-title">Restorative Dentistry</h2>
                <p className="procedure-card-text">
                    Looking to enhance your smile? Relieve tooth pain? Should your teeth ever require a restorative treatment, you can rest assured knowing we will always find and recommend what we believe to be the most comfortable and least invasive treatment.  
                </p>
                <p className="procedure-card-text">
                    Providing you with excellent care is our number one priority when creating your beautiful smile.
                </p>
                <div className="procedure-custom-line"></div>
                <ul className="procedure-card-selection">
                    <li className="procedure-card-item">
                        <Link to="/procedures/composite-fillings" className="procedure-card-link">Composite Filling</Link>
                    </li>
                    <li className="procedure-card-item">
                        <Link to="/procedures/crowns" className="procedure-card-link">Crowns</Link>
                    </li>
                </ul>
            </div>
            <div className="procedure-card"> 
                <img src="/images/prosthodontics.jpeg" alt="Cosmetic Dentistry" className="procedure-card-image" />
                <h2 className="procedure-card-title">Prosthodontics</h2>
                <p className="procedure-card-text">
                    Prosthodontics is the area of dentistry that focuses on restoring and replacing teeth. 
                    Our team is dedicated to providing you with the highest quality of care and the most advanced techniques in prosthodontics.
                </p>
                <p className="procedure-card-text">
                    Check out the links below to see how we can help you with your prosthodontic needs.
                </p>
                <div className="procedure-custom-line"></div>
                <ul className="procedure-card-selection">
                    <li className="procedure-card-item">
                        <Link to="/procedures/fixed-bridges" className="procedure-card-link">Fixed Bridges & Crowns</Link> {/* Include info about crowns in corresponding page*/}
                    </li>
                    <li className="procedure-card-item">
                        <Link to="/procedures/partial-dentures" className="procedure-card-link">Partial Dentures</Link>
                    </li>
                </ul>
            </div>
        </div>    
        <div className="procedure-cards">
            <div className="procedure-card">
                <img src="/images/periodontic-health.jpeg" alt="Periodontic Health" className="procedure-card-image" />
                <h2 className="procedure-card-title">Periodontic Health</h2>
                <p className="procedure-card-text">
                    Periodontal disease attacks the gums and the bone that support the teeth, characterized by red, swollen, and bleeding gums.
                    Four out of five adults have some form of periodontal disease, and it is the leading cause of tooth loss in adults.
                </p>
                <p className="procedure-card-text">
                    Check out the links below to see how we can help you in treatment or maintenance of your periodontal health.
                </p>
                <div className="procedure-custom-line"></div>
                <ul className="procedure-card-selection">
                    <li className="procedure-card-item">
                        <Link to="/procedures/periodontic-diagnosis" className="procedure-card-link">Diagnosis</Link>
                    </li>
                    <li className="procedure-card-item">
                        <Link to="/procedures/periodontic-treatment" className="procedure-card-link">Treatment & Maintenance</Link>
                    </li>
                </ul>
            </div>
            <div className="procedure-card">
                <img src="/images/oral-surgery.jpeg" alt="Oral Surgery" className="procedure-card-image" />
                <h2 className="procedure-card-title">Oral Surgery</h2>
                <p className="procedure-card-text">
                    Oral surgery is a branch of dentistry that deals with the diagnosis and surgical treatment of diseases, injuries, and defects of the oral and maxillofacial region.
                </p>
                <p className="procedure-card-text">
                    Our team is dedicated to providing you with the highest quality of care and the most advanced techniques
                    in oral surgery. We understand that oral surgery can be a daunting experience, and we are here to help you every step of the way
                </p>
                <div className="procedure-custom-line"></div>
                <ul className="procedure-card-selection">
                    <li className="procedure-card-item">Extractions</li>
                </ul>
            </div>
            <div className="procedure-card">
                <img src="/images/endodontics.jpeg" alt="Endodontics" className="procedure-card-image" />
                <h2 className="procedure-card-title">Endodontics</h2>
                <p className="procedure-card-text">
                    Endodontics is the branch of dentistry that deals with the diagnosis and treatment of diseases and injuries of the dental pulp and surrounding tissues.
                    Our team is dedicated to providing you with the highest quality of care and the most advanced techniques in endodontics.
                </p>
                <p className="procedure-card-text">
                    Check out the links below to see how we can help you with your endodontic needs.
                </p>
                <div className="procedure-custom-line"></div>
                <ul className="procedure-card-selection">
                    <li className="procedure-card-item">Root Canal Treatments</li>
                </ul>
            </div>
        </div>     
      </div>
        

    </div>
  );
}

export default ProceduresContent;
